import { render, staticRenderFns } from "./signFailed.vue?vue&type=template&id=c9324872&scoped=true&"
import script from "./signFailed.vue?vue&type=script&lang=js&"
export * from "./signFailed.vue?vue&type=script&lang=js&"
import style0 from "./signFailed.vue?vue&type=style&index=0&id=c9324872&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9324872",
  null
  
)

export default component.exports